import { useMemo, useRef, type PropsWithChildren } from 'react';
import type {
  ConversationView,
  ConversationViewRegistry,
} from '../types/conversation-view.types';
import { ConversationViewContext } from './conversation-view-context';

/** Shares mounted chat visibility without coupling either feature to the other. */
export const ConversationViewProvider = ({ children }: PropsWithChildren) => {
  const views = useRef(new Map<symbol, ConversationView>());
  const registry = useMemo<ConversationViewRegistry>(
    () => ({
      getView: () => {
        const current = [...views.current.values()];
        return current[current.length - 1] ?? null;
      },
      register: (view) => {
        const token = Symbol();
        views.current.set(token, view);
        return () => {
          views.current.delete(token);
        };
      },
    }),
    []
  );
  return (
    <ConversationViewContext.Provider value={registry}>
      {children}
    </ConversationViewContext.Provider>
  );
};
